import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code';
//COMPONENTS
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../../Alerts/ErrorAlert';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import LoadingAlert from '../../Alerts/LoadingAlert';
import AlertSmall from '../../Alerts/AlertSmall';

//APIS
import { MailFetchAPI } from '../../../api/Mail';
import { WhatsappFetchAPI } from '../../../api/Whatsapp';


function ModalSendLinkPayment({ sendLinkPayment, setSendLinkPayment, PreOrderDataCallCenter, dataClientSelected, dataOrder, domain, buttonNewOrder }) {

    const [emailSendLink, setEmailSendLink] = useState("");
    const [phoneSendLink, setPhoneSendLink] = useState("");
    const [key, setKey] = useState('phone');
    const [url, setUrl] = useState(``);



    //Send email with payment link to customer
    const sendMailValid = () => {
        let token = localStorage.getItem('x-access-machine-token')
        if (emailSendLink == "" || emailSendLink == undefined || emailSendLink == null) {
            ErrorAlert("", "Ingrese un correo valido", "error")
            return
        } else {


            //let url = `https://${domain}/cart/order/${code}`
            //let url = `https://1h8p3t4t-3002.use2.devtunnels.ms/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
            //let url = `http://localhost:3002/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
            let data = {
                "email": emailSendLink,
                "subject": "Link de pago",
                "text": url,
            }

            console.log(data);
            try {
                const response = MailFetchAPI.sendMail(data, token)
                ErrorAlert('', 'Correo enviado con exito', 'success')
            } catch (err) {
                setSendLinkPayment(false)
                ErrorAlert('', err.response.data ? err.response.data.error : "Error al enviar correo", 'error')
                console.log(err)
            }
        }
    }

    const sendMessage = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))
        //let url = `https://${domain}/cart/order/${code}`
        //let url = `https://1h8p3t4t-3002.use2.devtunnels.ms/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
        let dataClient = {
            "notification_type": "smartpay_notification",
            "branchoffice_id": branchoffice.id,
            "business_id": business.id,
            "phone_to_send": phoneSendLink,
            "header_text": "Link de pago",
            "message_body": [{ "text": "Smartpay" }, { "text": `Link de pago url:  ${url}` }]
        }
        try {
            const response = await WhatsappFetchAPI.sendNotificationWhatsapp(dataClient, token)
            ErrorAlert("Exito", "Mensaje enviado correctamente", "success")


        } catch (err) {
            ErrorAlert("Opps..", "No se pudo enviar el mensaje", "error")
            console.log(err);
        }
    }

    const updatePage = () => {
        window.location.reload()
    }



    useEffect(() => {
        if (dataClientSelected != null && dataClientSelected.email != "") {
            setEmailSendLink(dataClientSelected.email);
        } else {
            setEmailSendLink("");
        }

        if (dataClientSelected != null && dataClientSelected.phone != "") {
            setPhoneSendLink(dataClientSelected.phone);
        } else {
            setPhoneSendLink("");
        }

        if (PreOrderDataCallCenter != null && PreOrderDataCallCenter.code != "" && PreOrderDataCallCenter._id != "") {
            setUrl(`https://${domain}/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`);
        } else {
            setUrl("");
        }


    }, [dataOrder, dataClientSelected, PreOrderDataCallCenter])

    return (
        <>

            {/* ── MODAL CREAR LINK DE PAGO — reemplaza tu <Modal>.
     NO cambia lógica: sendLinkPayment/setSendLinkPayment, url, QRCode, AlertSmall,
     key/setKey (tabs email|phone), emailSendLink/phoneSendLink + setters, buttonNewOrder,
     LoadingAlert, updatePage, sendMailValid, sendMessage. Requiere: import './LinkPaymentModal.css'; ── */}

            <Modal
                show={sendLinkPayment}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName="sp-lp-dialog"
                contentClassName="sp-lp-content"
            >
                <Modal.Body className="sp-lp">

                    {/* Header */}
                    <div className="sp-lp__head">
                        <div className="sp-lp__badge"><i className="uil uil-shopping-bag"></i></div>
                        <h2 className="sp-lp__title">Crear link de pago</h2>
                    </div>

                    {/* QR */}
                    <div className="sp-lp__qrsect">
                        <span className="sp-lp__label">Envío de link de pago</span>
                        <div className="sp-lp__qr">
                            <QRCode value={url} size={150} bgColor="#ffffff" fgColor="#0F1B30" level="H" />
                        </div>
                    </div>

                    {/* Compartir link */}
                    <div className="sp-lp__share">
                        <span className="sp-lp__label">o comparte el link</span>
                        <div className="sp-lp__shareacts">
                            <button className="sp-lp__btn sp-lp__btn--primary" onClick={() => window.open(url, '_blank')}>
                                <i className="uil uil-external-link-alt"></i> Ir a página
                            </button>
                            <button className="sp-lp__btn sp-lp__btn--outline" onClick={() => (AlertSmall("Link copiado con exito", "success"), navigator.clipboard.writeText(url))}>
                                <i className="uil uil-copy"></i> Copiar Link
                            </button>
                        </div>
                    </div>

                    {/* Tabs Email / WhatsApp */}
                    <div className="sp-lp__tabs">
                        <button type="button" className={`sp-lp__tab ${key === 'email' ? 'is-active' : ''}`} onClick={() => setKey('email')}>
                            <i className="uil uil-envelope-upload"></i> Email
                        </button>
                        <button type="button" className={`sp-lp__tab ${key === 'phone' ? 'is-active' : ''}`} onClick={() => setKey('phone')}>
                            <i className="uil uil-whatsapp"></i> Whatsapp
                        </button>
                    </div>

                    <div className="sp-lp__pane">
                        {key === 'email' && (
                            <div className="sp-lp__field">
                                <label className="sp-lp__flabel"><i className="uil uil-envelope-upload"></i> Ingrese el correo</label>
                                <input type="text" className="sp-lp__input" placeholder="email@example.com"
                                    value={emailSendLink} onChange={(e) => setEmailSendLink(e.target.value)} />
                            </div>
                        )}
                        {key === 'phone' && (
                            <div className="sp-lp__field">
                                <label className="sp-lp__flabel"><i className="uil uil-whatsapp"></i> Ingrese el numero de telefono</label>
                                <input type="text" className="sp-lp__input" placeholder="+507 6000-0000"
                                    value={phoneSendLink} onChange={(e) => setPhoneSendLink(e.target.value)} />
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="sp-lp__foot">
                        {buttonNewOrder == true ? <>
                            <button className="sp-lp__btn sp-lp__btn--info" onClick={() => (LoadingAlert(), updatePage())}>
                                <i className="uil uil-file-plus-alt"></i> Nueva orden
                            </button>
                        </> : <>
                            <button className="sp-lp__btn sp-lp__btn--cancel" onClick={() => setSendLinkPayment(false)}>
                                <i className="uil uil-times-circle"></i> Cerrar
                            </button>
                        </>}

                        <button className="sp-lp__btn sp-lp__btn--ok" onClick={() => { if (key === "email") { sendMailValid() } else { sendMessage() } }}>
                            <i className="uil uil-envelope-send"></i> Enviar Link de pago
                        </button>
                    </div>

                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalSendLinkPayment